import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'who',
    template: require('./who.component.html')
})

export class WhoComponent {

    constructor(public router: Router) {
    }

}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/front/who/who.component.ts
 **/